import React, { useEffect, useState } from "react";
import { Modal, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import close_icon from "../assets/img/close.svg";
import Multiselect from "../Customcomponents/Multiselect";
import {
  fetchPendingAllocations,
  getProfile,
  allocateProjectTeam,
} from "../api/service";
import { headAndTeamMembers } from "../components/utils";

// F2: Allocation-Pending screen for civil_head / design_head users.
// Lists projects that still need a team member of the viewer's team role.
export default function PendingAllocations() {
  const currentUserRole = localStorage.getItem("role");
  const teamRole = headAndTeamMembers[currentUserRole];

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [assignees, setAssignees] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  function loadRows() {
    setLoading(true);
    fetchPendingAllocations()
      .then((res) => setRows(Array.isArray(res) ? res : []))
      .catch((err) => {
        toast.error(err?.message || "Failed to load pending allocations");
        setRows([]);
      })
      .finally(() => setLoading(false));
  }

  function loadAssignees() {
    if (!teamRole) return;
    getProfile({
      pagination: false,
      role: `${currentUserRole},${teamRole}`,
      active: "True",
    })
      .then((res) => setAssignees(Array.isArray(res) ? res : []))
      .catch(() => setAssignees([]));
  }

  useEffect(() => {
    loadRows();
    loadAssignees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function openAllocate(project) {
    setSelectedProject(project);
    // The endpoint returns lightweight rows (no users_assigned), so start with empty selection.
    setSelectedAssignees([]);
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
    setSelectedProject(null);
    setSelectedAssignees([]);
    setDropdownVisible(false);
  }

  function getIds(list) {
    return (list || []).map((u) => u.id);
  }

  function submitAllocation() {
    if (!selectedProject) return;
    const ids = getIds(selectedAssignees);
    if (ids.length === 0) {
      toast.error("Please select a team member to allocate");
      return;
    }
    // Mirror Salesprojects.jsx Add Assignee: PATCH the project with the new users_assigned list.
    allocateProjectTeam(selectedProject.id, ids)
      .then(() => {
        toast.success("Team member allocated successfully");
        closeModal();
        loadRows(); // the allocated project should disappear from the list
      })
      .catch((err) => {
        toast.error(err?.message || "Failed to allocate team member");
      });
  }

  const titleLabel =
    currentUserRole === "civil_head"
      ? "Pending Civil Team Allocations"
      : currentUserRole === "design_head"
      ? "Pending Design Team Allocations"
      : "Pending Allocations";

  const isHead =
    currentUserRole === "civil_head" || currentUserRole === "design_head";

  if (!isHead) {
    return (
      <div className="p-4">
        <h3>Allocations</h3>
        <p>This screen is only available to Civil Head and Design Head users.</p>
      </div>
    );
  }

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="headingfour m-0">{titleLabel}</h3>
        <div>
          <span className="text-muted">
            {loading ? "Loading…" : `${rows.length} project(s) pending`}
          </span>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Project ID</th>
              <th>Customer</th>
              <th>Status</th>
              <th>Days Pending</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={5} className="text-center text-muted">
                  Loading…
                </td>
              </tr>
            )}
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center text-muted">
                  No pending allocations. All active projects have a{" "}
                  {teamRole ? teamRole.replace("_", " ") : "team"} member assigned.
                </td>
              </tr>
            )}
            {!loading &&
              rows.map((row) => (
                <tr key={row.id}>
                  <td>Proj {row.id}</td>
                  <td>{row.customer_name || "-"}</td>
                  <td>{row.status || "-"}</td>
                  <td>
                    {row.days_pending_allocation}
                    {row.days_pending_allocation === 1 ? " day" : " days"}
                  </td>
                  <td>
                    <input
                      type="button"
                      value="Allocate"
                      className="signup_button"
                      onClick={() => openAllocate(row)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <h1 className="headingfour">
            Allocate{" "}
            {teamRole
              ? teamRole.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())
              : "Team"}{" "}
            Member
          </h1>
          <img
            src={close_icon}
            alt="close"
            onClick={closeModal}
            style={{ cursor: "pointer" }}
          />
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <div className="mb-2">
                <strong>Project:</strong> Proj {selectedProject?.id} —{" "}
                {selectedProject?.customer_name}
              </div>
              <Multiselect
                assignees={assignees}
                setAssignees={setAssignees}
                selectedAssignees={selectedAssignees}
                setselectedAssignees={setSelectedAssignees}
                dropdownVisible={dropdownVisible}
                setDropdownVisible={setDropdownVisible}
              />
            </Row>

            <hr />

            <div className="d-flex justify-content-start align-items-center gap-2">
              <input
                type="button"
                value="Cancel"
                className="outline_btn"
                onClick={closeModal}
              />
              <input
                type="button"
                value="Submit"
                className="signup_button"
                onClick={submitAllocation}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
